import { UserCreDB, UserCreDBCache } from "../types/user";
import {
  transformToCache,
  transformToObj,
} from "../components/shared/utils/transformers";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { asyncStorageService } from "../components/shared/services/async-store";

export const userFieldTypes = {
  location: "object",
  preferences: "object",
  contactInfo: "object",
} as const;

export class UserDBService {
  USER_KEY_PREFIX = "@UserStore:";

  transformToUser(cache: UserCreDBCache): UserCreDB {
    return transformToObj<UserCreDB, UserCreDBCache>(cache, userFieldTypes);
  }

  transformToCache(user: UserCreDB): UserCreDBCache {
    return transformToCache<UserCreDB, UserCreDBCache>(user, userFieldTypes);
  }

  async saveUser(user: UserCreDB): Promise<void> {
    const key = `${this.USER_KEY_PREFIX}${user.userId}`;
    const cache = this.transformToCache(user);
    await asyncStorageService.setData(key, cache);
  }

  async getUser(userId: string): Promise<UserCreDB | null> {
    const key = `${this.USER_KEY_PREFIX}${userId}`;
    const data = await asyncStorageService.getData<any>(key);
    if (!data) return null;
    return this.transformToUser(data);
  }
}

export const userDbService = new UserDBService();
